// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"182":"CompanyDetails","589":"RegistrationManager"}[chunkId] || chunkId) + "." + {"182":"4c114e67","453":"56ef9deb","589":"0880e91e"}[chunkId] + ".chunk.js";
};